import CityPageTemplate from "../city-template/CityPageTemplate";
import { farmingtonConfig } from "./data";

export default function FarmingtonPage() {
  return <CityPageTemplate config={farmingtonConfig} />;
}